// The time zone a report's `ProjectInfo.timeZone` names: the viewer's own, as the browser reports
// it — an IANA id such as `Asia/Hong_Kong` — or `UTC` when the browser reports none.
//
// The report service hands it to the RDLs' `Code.FromUTC(…, tz)`, which calls
// `TimeZoneInfo.FindSystemTimeZoneById(tz)` to print the footer's "Report generated" time in that
// zone; the service runs .NET 9 with ICU, which resolves IANA ids. An unknown id would make that
// footer expression fail, so anything the browser cannot name (no `Intl`, an empty value, ICU's
// `Etc/Unknown`) falls back to `UTC`, the value both apps sent before 2026-10-28.
export const DEFAULT_REPORT_TIME_ZONE = 'UTC';

/** @returns {string} the browser's IANA time zone, or `UTC` */
export function reportTimeZone() {
    try {
        const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return zone && zone !== 'Etc/Unknown' ? zone : DEFAULT_REPORT_TIME_ZONE;
    } catch {
        return DEFAULT_REPORT_TIME_ZONE;
    }
}
